<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <h1 class="fw-bold page-title d-none">Εκπαιδευτικό υλικό</h1>
            <div class="row clearfix">
                <div class="shadow py-4 my-3 px-3 rounded">
                    <h2 class="text-primary fw-bold">Tutorials</h2>
                    <hr>
                    <div class="row text-center">
                        <div class="col">
                            <div style="width: 100%;">
                                <iframe width="100%" height="420"
                                    src="https://www.youtube.com/embed/pibhuQmClEw?si=iCKP4O5NidF3bDUY" title="YouTube
                                    video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-
                                    media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-
                                    origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-toastification/dist/index.css';

export default {
    metaInfo: {
        title: 'Πρωοθητικό υλικό',
        meta: [
            { name: 'description', content: 'Πρωοθητικό υλικό' },
            { property: 'og:title', content: 'Πρωοθητικό υλικό' },
            { property: 'og:description', content: 'Πρωοθητικό υλικό' }
        ]
    }
};
</script>

<style scoped>
    
</style>
